import { menuIcons, videoIcons } from "../../../../../app/config/config";
import {
  getDashboardPermissions,
  assistantPermissions,
  budgetPermissions,
  administrationPermissions,
  administrationClientPermissions,
  getMedicalPermissions,
  getImsPermissions,
  warehousePermissions,
  warehouseItemPermissions,
  getRequestsPermissions,
  getSummariesPermissions,
  getSummaryItemPermissions,
  getSummaryServicesPermissions,
  getEventsPermissions,
  getArticoliEventoViewPermissions,
  getSalesPermissions,
  getSalesItemPermissions,
  getSalesClientPermissions,
  getSalesSummaryPermissions,
  filesPermissions,
  arubaMailPermissions,
  epsMailPermissions,
  learningAdminRoles,
  learningViewerRoles,
  getLearningMenuPermissions,
  getLearningResultsPermissions,
} from "../../../../../app/permissions";
/* Configurazione permessi menù */
/* Menu Laterale */
export default function getMenuConfig(userIsAgente, user) {
  const items = [
    {
      type: "item",
      title: "Dashboard",
      url: "/dashboard",
      icon: menuIcons.dashboard,
      openInNewWindow: false,
      allowedRoles: getDashboardPermissions(userIsAgente),
    },
    // Sezione: Assitente IA
    {
      type: "item",
      title: "Assistente Virtuale",
      url: "/ai-assistant",
      icon: menuIcons.ai,
      openInNewWindow: false,
      allowedRoles: assistantPermissions,
    },
    {
      type: "item",
      title: "Budget",
      url: "/budget",
      icon: menuIcons.selling,
      openInNewWindow: false,
      allowedRoles: budgetPermissions,
    },
    {
      type: "submenu",
      title: "Formazione",
      url: "/learning-menu",
      icon: videoIcons.learning,
      openInNewWindow: false,
      allowedRoles: getLearningMenuPermissions(userIsAgente),
      items: [
        {
          type: "item",
          title: "Gestisci Corsi",
          url: "/admin/learning",
          icon: videoIcons.manage,
          openInNewWindow: false,
          allowedRoles: learningAdminRoles,
        },
        {
          type: "item",
          title: "Risultati",
          url: "/admin/learning-results",
          icon: videoIcons.results,
          openInNewWindow: false,
          allowedRoles: getLearningResultsPermissions(userIsAgente),
        },
        {
          type: "item",
          title: "Quiz Builder",
          url: "/admin/learning-quiz",
          icon: videoIcons.quizBuilder,
          openInNewWindow: false,
          allowedRoles: learningAdminRoles,
        },
        {
          type: "item",
          title: "Sfoglia Corsi",
          url: "/learning-videos",
          icon: videoIcons.course,
          openInNewWindow: false,
          allowedRoles: learningViewerRoles,
        },
      ],
    },
    {
      type: "submenu",
      title: "Dati Ims",
      url: "/ims-menu",
      icon: menuIcons.ims,
      openInNewWindow: false,
       allowedRoles: getImsPermissions(userIsAgente),
      items: [
        {
          title: "Consulta Dati IMS",
          url: "/ims",
          icon: menuIcons.ims,
          allowedRoles: getImsPermissions(userIsAgente),
        },
        {
          title: "Videoguida",
          url: "/ims-videoguida",
          icon: menuIcons.ims,
          allowedRoles: getImsPermissions(userIsAgente),
        },
      ],
    },

    // Sezione: Amministrazione
    {
      type: "submenu",
      title: "Anagrafiche",
      icon: menuIcons.admin,
      url: "/admin",
       allowedRoles: administrationPermissions,
      items: [
        {
          title: "Utenti",
          url: "/admin/utenti/",
          icon: menuIcons.admin,
           allowedRoles: administrationPermissions,
        },
        {
          title: "Clienti",
          url: "/clienti/",
          icon: menuIcons.clients,
           allowedRoles: administrationClientPermissions,
        },
      ],
    },

    // Sezione: Medici
    {
      type: "submenu",
      title: "Medici",
      icon: menuIcons.book,
      url: "#",
       allowedRoles: getMedicalPermissions(userIsAgente),
      items: [
        {
          title: "Medici",
          url: "/medici/",
          icon: menuIcons.medics,
           allowedRoles: getMedicalPermissions(userIsAgente),
        },
        {
          title: "Centri",
          url: "/centri/",
          icon: menuIcons.centers,
           allowedRoles: getMedicalPermissions(userIsAgente),
        },
      ],
    },

    // Sezione: Magazzino
    {
      type: "submenu",
      title: "Magazzino",
      icon: menuIcons.magazzino,
      url: "#",
       allowedRoles: warehousePermissions,
      items: [
        {
          title: "Prodotti",
          url: "/gestione-prodotti/",
          icon: menuIcons.products,
           allowedRoles: warehouseItemPermissions,
        },
        {
          title: "Campioni",
          url: "/gestione-campioni/",
          icon: menuIcons.products,
           allowedRoles: warehouseItemPermissions,
        },
        {
          title: "Materiale Pubblicitario",
          url: "/gestione-materiale/",
          icon: menuIcons.marketing_material,
           allowedRoles: warehouseItemPermissions,
        },
      ],
    },

    // Sezione: Richieste
    {
      type: "submenu",
      title: "Campioni e Servizi",
      icon: menuIcons.cart,
      url: "#",
       allowedRoles: getRequestsPermissions(userIsAgente),
      items: [
        {
          type: "item",
          title: "Campioni",
          url: "/richiesta-campioni/",
          icon: menuIcons.campioni,
           allowedRoles: getRequestsPermissions(userIsAgente),
        },
        {
          type: "item",
          title: "Materiale Pubblicitario",
          url: "/richiesta-materiale/",
          icon: menuIcons.marketing_material,
           allowedRoles: getRequestsPermissions(userIsAgente),
        },
        {
          type: "item",
          url: "/servizi/",
          title: "Servizi",
          icon: menuIcons.services,
           allowedRoles: getRequestsPermissions(userIsAgente),
        },
      ],
    },

    // Sezione: Riepiloghi
    {
      type: "submenu",
      title: "Riepiloghi",
      icon: menuIcons.list,
      url: "#",
       allowedRoles: getSummariesPermissions(userIsAgente),
      items: [
        {
          type: "item",
          title: "Campionatura",
          url: "/status-campionatura-servizi/",
          icon: menuIcons.status,
           allowedRoles: getSummaryItemPermissions(userIsAgente),
        },
        {
          type: "item",
          title: "Materiale Pubblicitario",
          url: "/status-campionatura-servizi/#/materiale-pubblicitario",
          icon: menuIcons.status,
           allowedRoles: getSummaryItemPermissions(userIsAgente),
        },
        {
          type: "item",
          title: "Servizi",
          url: "/status-campionatura-servizi/#/servizi",
          icon: menuIcons.services,
           allowedRoles: getSummaryServicesPermissions(userIsAgente),
        },
        {
          type: "item",
          title: "Campioni Eventi",
          url: "/campioni-eventi/",
          icon: menuIcons.magazzino,
           allowedRoles: getArticoliEventoViewPermissions(userIsAgente),
        },
      ],
    },

    // Sezione: Eventi
    {
      type: "submenu",
      title: "Eventi",
      icon: menuIcons.events,
      url: "/eventi",
       allowedRoles: getEventsPermissions(userIsAgente),
      items: [
        {
          title: "Calendario",
          url: "/calendario/",
          icon: menuIcons.calendar,
           allowedRoles: getEventsPermissions(userIsAgente),
        },
        {
          title: "Agenda",
          url: "/agenda/",
          icon: menuIcons.calendar,
           allowedRoles: getEventsPermissions(userIsAgente),
        },
        // {
        //   title: "Richieste",
        //   url: "/richiesta-ferie-permessi/",
        //   icon: menuIcons.status,
        //   allowedRoles: [roles.developer],
        // },
      ],
    },

    // Sezione Vendite
    {
      type: "submenu",
      title: "Vendite Dirette",
      icon: menuIcons.selling,
      url: "#",
       allowedRoles: getSalesPermissions(userIsAgente, user),
      items: [
        {
          type: "item",
          title: "Vendite Dirette",
          url: "/richiesta-prodotti/",
          icon: menuIcons.selling,
           allowedRoles: getSalesItemPermissions(userIsAgente),
        },
        {
          type: "item",
          title: "Clienti",
          url: "/clienti/",
          icon: menuIcons.clients,
           allowedRoles: getSalesClientPermissions(userIsAgente),
        },
        {
          type: "item",
          title: "Riepilogo vendita",
          url: "/status-vendita/",
          icon: menuIcons.status,
           allowedRoles: getSalesSummaryPermissions(userIsAgente),
        },
      ],
    },
    // Sezione: File
    {
      type: "item",
      title: "File",
      url: "/file/",
      icon: menuIcons.files,
       allowedRoles: filesPermissions,
    },

    // Sezione: Webmail
    {
      type: "item",
      title: "Aruba Mail",
      url: "https://webmail.aruba.it/ ",
      icon: menuIcons.mail,
      openInNewWindow: true,
       allowedRoles: arubaMailPermissions,
    },

    {
      type: "item",
      title: "Eps Mail",
      url: "http://mail.dcrpharma.it/",
      icon: menuIcons.mail,
      openInNewWindow: true,
       allowedRoles: epsMailPermissions,
    },
  ];
  return items;
}
